import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {SorobanBasicFlashCardPage} from "../soroban-basic-flash-card/soroban-basic-flash-card";
import {SorobanBasicBasicPage} from "../soroban-basic-basic/soroban-basic-basic";
import {SorobanBasicLittleFriendPlusPage} from "../soroban-basic-little-friend-plus/soroban-basic-little-friend-plus";
import {SorobanBasicLittleFriendMinusPage} from "../soroban-basic-little-friend-minus/soroban-basic-little-friend-minus";
import {SorobanBasicBigFriendPlusPage} from "../soroban-basic-big-friend-plus/soroban-basic-big-friend-plus";
import {SorobanBasicBigFriendMinusPage} from "../soroban-basic-big-friend-minus/soroban-basic-big-friend-minus";
import {SorobanBasicPlusMinusPage} from "../soroban-basic-plus-minus/soroban-basic-plus-minus";
import {SorobanBasicLittleFriendMixPage} from "../soroban-basic-little-friend-mix/soroban-basic-little-friend-mix";
import {SorobanBasicBigFriendMixPage} from "../soroban-basic-big-friend-mix/soroban-basic-big-friend-mix";

/**
 * Generated class for the SorobanBasicBoardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-soroban-basic-board',
    templateUrl: 'soroban-basic-board.html',
})
export class SorobanBasicBoardPage {

    sorobanBasicFlashCardPage = SorobanBasicFlashCardPage;
    sorobanBasicBasicPage = SorobanBasicBasicPage;
    sorobanBasicLittleFriendPlusPage = SorobanBasicLittleFriendPlusPage;
    sorobanBasicLittleFriendMinusPage = SorobanBasicLittleFriendMinusPage;
    sorobanBasicLittleFriendMixPage = SorobanBasicLittleFriendMixPage;
    sorobanBasicBigFriendPlusPage = SorobanBasicBigFriendPlusPage;
    sorobanBasicBigFriendMinusPage = SorobanBasicBigFriendMinusPage;
    sorobanBasicBigFriendMixPage = SorobanBasicBigFriendMixPage;
    sorobanBasicPlusMinusPage = SorobanBasicPlusMinusPage;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad SorobanBasicBoardPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/soroban-basic-board/soroban-basic-board.ts